<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina
                Titlu="Clienti"
                @on_add_clicked="show_dialog()"
                :AdaugaVisible="true"
              />
            </div>
          </template>
      <div class="filtre">
        <el-form @submit.prevent.native="refresh_info()">
          <el-row style="margin: 10px" class="input-group">
            <el-col class="input-element">
              <el-form-item label="Nume">
                <el-input v-model="Filters.Nume" />
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label="Prenume">
                <el-input v-model="Filters.Prenume" />
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label="Email">
                <el-input v-model="Filters.Email" />
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label="Telefon">
                <el-input v-model="Filters.Telefon" />
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-button
                type="primary"
                native-type="submit"
                @click="refresh_info()"
              >
                Aplica
              </el-button>
              <el-button type="danger" native-type="submit" @click="reset()">
                Reseteaza
              </el-button>
            </el-col>
          </el-row>
        </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-table :data="Results" class="tabelRandMic">
      <el-table-column label="#" width="60px">
        <template slot-scope="scope">
          <el-tooltip :content="'Id client EVIO: ' + scope.row.IdClientEvio">
            <span>{{scope.row.Id}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="Nume" label="Nume"/>
      <el-table-column prop="Prenume" label="Prenume" />
      <el-table-column prop="Email" label="Email" min-width="150px"/>
      <el-table-column prop="Telefon" label="Telefon" align="right" />
      <el-table-column label="Numar masini" align="center" width="120px" >
        <template slot-scope="scope"> 
          {{ scope.row.NumarMasiniClient }}
        </template>
      </el-table-column>  
      <el-table-column fixed="right" align="right" label="Actiuni" width="240px">
        <template slot-scope="scope">
          <el-tooltip  content="Adauga programare noua">
            <el-button size="mini"
            :disabled="scope.row.NumarMasiniClient == 0"
              class="butonReg"
              type="success"
              icon="el-icon-plus"
              circle
              @click="programare_noua(scope.row)"
              />
          </el-tooltip>
          <el-tooltip content="Vezi programari viitoare">
            <el-button size="mini"
              class="butonReg"
              icon="el-icon-view"
              circle
              @click="deschide_link_programari(scope.row)"
              />
          </el-tooltip>
          <el-tooltip content="Vezi istoric">
            <el-button size="mini"
            class="butonReg"
              type="info"
              icon="el-icon-right"
              circle
              @click="deschide_link(scope.row)"
              />
          </el-tooltip>
          <el-tooltip content="Copiaza link in clipboard">
            <el-button size="mini"
              type="info"
              class="butonReg"
              icon="el-icon-document-copy"
              circle
              @click="copiaza_link(scope.row)"
              />
          </el-tooltip>
          <el-tooltip content="Modificare">
            <el-button size="mini"
              type="primary"
              class="butonReg"
              icon="el-icon-edit"
              circle
              @click="show_dialog(scope.row.Id)"
            />
          </el-tooltip>

          <el-tooltip content="Sterge">
            <el-button size="mini"
              type="danger"
              class="butonReg"
              icon="el-icon-delete"
              circle
              @click="delete_item(scope.row)"
            />
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="refresh_info"
      @current-change="refresh_info"
      :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page"
      :total="PaginationInfo.RowCount"
      layout="pager"
    />
    <el-dialog title="Selecteaza masina pentru programare" :visible.sync="showPopupProgramareNoua" width="30%" append-to-body>
        <el-select size="small" v-model='IdMasinaSelectataProgramare' class='full-width' filterable >
            <el-option v-for='item in masini_disponibile_client' :key="'masini_client' + item.Id" :label='item.Numar' :value='item.Id' />
        </el-select>
        <span slot="footer" class="dialog-footer" >   
            <el-button size="small" :disabled="this.IdMasinaSelectataProgramare == ''" type="success" @click="adauga_programarea()" >Programeaza</el-button>
        </span>
    </el-dialog>
    <Clienti-dialog ref="dlg" @save="refresh_info()" />
    <Rezervari-dialog v-show="false" ref="dlg_rez" @save="refresh_info()" />
  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import Clienti_dialog from "@/pages/Admin/clienti/Clienti_dialog.vue";
import Rezervari_dialog from "@/pages/Receptie/Rezervari_list.vue";
import TitluPagina from "@/widgets/TitluPagina";
// import { compareNumbers } from '@fullcalendar/vue';

export default {
  name: "clienti",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "Clienti-dialog": Clienti_dialog,
    "Rezervari-dialog": Rezervari_dialog,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {
      clientProgramareNoua: {},
      masini_disponibile_client: '',
      IdMasinaSelectataProgramare: '',
      showPopupProgramareNoua: false,
      Results: [],
      base_url: "",
      Info: {},
      Filters: {
        Nume: "",
        Prenume: "",
        Email: "",
        Telefon: "",
      },
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },
  methods: {
    async deschide_link(item) {

      var response = await this.post("admin/clienti/get_md5mail_client", { idClient: item.Id });
      if(response && response.Md5Mail != '')
        window.open( settings.BASE_PROGRAMARI_FRONTEND_URL + "#/istoric/"+response.Md5Mail,'_blank')
      else
        this.$message({ message: 'Nu exista programari pentru acest client', type: 'warning' });
    },
    async deschide_link_programari(item){
      try {
        const response = await this.post("admin/clienti/get_md5mail_client", { idClient: item.Id });
        if(response && response.Md5Mail != ''){
          window.open( settings.BASE_PROGRAMARI_FRONTEND_URL + "#/programari_viitoare/"+response.Md5Mail,'_blank')
        }else{
          this.$message({ message: 'Nu exista programari pentru acest client', type: 'warning' });
        }
      } catch (error) {
        console.error(error)
      }
    },
    
    async programare_noua(item) {

      console.log('aici')

      var response = await this.post("admin/clienti/get_masini_client", { idClient: item.Id });
      this.masini_disponibile_client = response.masiniClient;

      this.IdMasinaSelectataProgramare = '';

      this.clientProgramareNoua = item;

      // this.masini_disponibile_client = item.Masini;
      if(this.masini_disponibile_client.length == 1){
        console.log('e doar una')
        this.IdMasinaSelectataProgramare = this.masini_disponibile_client[0].Id;
      }
      this.showPopupProgramareNoua = true;

    },        
    
    async adauga_programarea() {

      let masina_selectata_client = this.masini_disponibile_client.filter((value) => value.Id == this.IdMasinaSelectataProgramare)[0];

      this.$refs.dlg_rez.programeaza_client(this.clientProgramareNoua, masina_selectata_client);

      this.showPopupProgramareNoua = false;

    },    

    async copiaza_link(item) {

      var response = await this.post("admin/clienti/get_md5mail_client", { idClient: item.Id });
      if(response && response.Md5Mail != ''){
        try {
          await navigator.clipboard.writeText(settings.BASE_PROGRAMARI_FRONTEND_URL + "#/istoric/"+response.Md5Mail);
          this.$message({ message: 'Linkul a fost adaugat in clipboard!', type: 'success' });
        } catch($e) {
          this.$message({ message: 'Eroare', type: 'error' });
        }

      }
      else
        this.$message({ message: 'Nu exista programari pentru acest client', type: 'warning' });



        
    
    },

    async get_info() {
      // var response = await this.post("admin/clienti/get_info");
      this.refresh_info();
    },

    async refresh_info() {
      var response = await this.post("admin/clienti/index", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      //
      this.select_menu_item("clienti_cat");
    },
    reset() {
      this.Filters = {
        Nume: "",
        Prenume: "",
        Email: "",
        Telefon: "",
      };
      this.refresh_info();
    },

    async delete_item(item) {
      var confirm = await this.$confirm(`Sunteti sigur ?`, "Warning");
      if (confirm) {
        await this.post("admin/clienti/delete_item", { id: item.Id });
        this.refresh_info();
      }
    },

    show_dialog(id) {
      this.$refs.dlg.show_me(id);
    },
  },
  mounted() {
    if (!this.$has_right("Management")) {
      this.$router.push("/no-rights");
      return;
    }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  width: 23%;
  margin-right: 2%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }
}
</style>
